export default __webpack_public_path__ + "static/2-9568cd8119421d47cfb53a2709552bf5.jpg";